"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.Result = function (_a) {
    var children = _a.children, correct = _a.correct, _b = _a.to, to = _b === void 0 ? "" : _b;
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.Result.displayName = "Result";
